import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "language", "hubId", "name"],
  _excluded2 = ["lesson"];
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import { useDataFetchingClient } from 'academy-common-lib/utils/DataFetchingClient';
import ChapterContent from '../../components/Chapter/ChapterContent';
import UsageTracker from '../../utils/UsageTracker';
import { updateContentProgress } from '../../features/userProgress';
import { Metrics } from '../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const ChapterContainer = _ref => {
  let {
      content: {
        id: contentId,
        language: contentLanguage,
        hubId: creatorHubId,
        name
      },
      track,
      lesson: {
        id: lessonId,
        visibility
      },
      contentProgress,
      onFinish
    } = _ref,
    restContent = _objectWithoutPropertiesLoose(_ref.content, _excluded);
  const client = useDataFetchingClient();
  const contents = 'contents' in restContent && restContent.contents ? restContent.contents : undefined;
  const handleComplete = () => {
    updateContentProgress({
      contentId,
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      language: contentLanguage
    }, client).then(() => {
      Metrics.counter('chapter-content-mutation', {
        action: 'chapter-progress-completed'
      }).increment();
    }).catch(error => {
      Metrics.counter('chapter-mutation-call-error', {
        action: 'chapter-progress-completed-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Chapter Progress Completed Error',
        action: 'chapter-progress-completed-error',
        error,
        additionalData: {
          contentId,
          lessonId,
          trackId: track === null || track === void 0 ? void 0 : track.id
        }
      });
    });
    UsageTracker.trackStandalone('Content Progress', {
      action: 'complete-chapter',
      contentId,
      contentLanguage,
      contentType: 'chapter',
      creatorHubId,
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      visibility: chirpEnumToString(visibility)
    });
  };
  return /*#__PURE__*/_jsx(ChapterContent, {
    advanceToNextContent: onFinish,
    completed: (contentProgress === null || contentProgress === void 0 ? void 0 : contentProgress.progressType) === 'COMPLETED',
    contentId: contentId,
    contentLanguage: contentLanguage,
    contents: contents,
    lessonId: lessonId,
    name: name,
    onComplete: handleComplete,
    trackId: track === null || track === void 0 ? void 0 : track.id,
    visibility: visibility
  });
};
const ChapterContentContainer = _ref2 => {
  let {
      lesson
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return lesson ? /*#__PURE__*/_jsx(ChapterContainer, Object.assign({
    lesson: lesson
  }, props)) : null;
};
export default ChapterContentContainer;